<script setup lang="ts">
import unnamed from '@/assets/image/unnamed.png'
import consola from 'consola'

enum LocaleMap {
  EN = 'en',
  TW = 'tw',
}

const { t, locale } = useI18n()
const route = useRoute()
// const router = useRouter()
const localPath = useLocalePath()
const Lang = ref<LocaleMap>(LocaleMap.TW)
if ((route.name as string)!.includes('___en')) {
  Lang.value = LocaleMap.EN
}

const moreRecipes = ref<_CookBookItem[]>([])

const { formatQuery } = useUseBeforeRequest()
const authStore = useAuthStore()
const cartStore = useCartStore()
const { recipeTypeOption } = useRecipeStore()
const tags = useState<_WCookbookType[]>('RecipeTags', () => [])
const user = useState<_JwtPayload | null>('user', () => null)

const userinfo = computed(() => {
  try {
    return user.value
  }
  catch (error) {
    consola.error(error)

    return authStore.userinfo
  }
})

const isLogin = computed(() => !!userinfo.value?.id)

await useFetch<_ResponseType<_Pagination<_CookBookItem[]>>>('/api/wCookbook/list', {
  params: {
    MESSAGE: formatQuery({
      customerId: userinfo.value?.id || 0,
      pageSize: 4,
      pageNo: 1,
      ctype: 0,
      cdes: 4,
    }),
  },
  onResponse({ response }) {
    if (response._data.success) {
      moreRecipes.value = response._data.data.records
    }
  },
})

// wCookbookTypeNew/typeListNewAC
await useFetch<_ResponseType<_WCookbookType[]>>('/api/wCookbookTypeNew/typeListNewAC', {
  params: {
    language: 'cn',
  },
  onResponse({ response, error }) {
    if (error) {
      return
    }
    const { data: originTag, success } = response._data
    if (!success)
      return
    tags.value = originTag.filter((item: _WCookbookTypeList) => item.type === 'cookbook')
  },
})

// const { data: hashTag } = await useAsyncData('HashTag', () => $fetch('/ichi_api/tag/list', {
//   method: 'POST',
//   params: {
//     size: 999999
//   }
// }))

// 难度
const rate = ref<number>(0)
// 是否购买
const isBay = ref<boolean>(false)

const { refresh } = await useFetch(`/ichi_api/cookbook/isBuy/${userinfo.value?.id}/${route.params.id}`, {
  onResponse({ response, error }) {
    if (error) {
      isBay.value = false
    }
    else {
      isBay.value = response._data.data
    }
  },
  immediate: false,
})

onBeforeMount(() => {
  if (userinfo.value) {
    refresh()
  }
})

const originIngredient = ref<_Ingredient[]>([])
const ingredient = ref<_Ingredient[]>([])
const checked = ref<number[]>([])
const stepsList = ref<_Step[]>([])

// 所需分量
const value2 = ref(1)

const { data, status } = await useFetch<_ResponseType<_RecipeDetail>>(`/api/cookbook/getInfo/${route.params.id}`, {
  params: {
    customerId: userinfo.value?.id,
    customerType: userinfo.value?.mbType,
  },
  onResponse({ response }) {
    const { code, msg } = response._data!
    if (code !== 200) {
      consola.error(msg)
      // useToast().error(msg)
      // showFailToast(msg)
    }
  },
})

/** 是否是作者 */
const isAuthor = computed(() => userinfo.value?.id === data.value?.data?.userId)

watch(() => status.value, (val) => {
  if (val === 'success') {
    ingredient.value = data.value!.data?.ingredients.map((item: _Ingredient) => ({ ...item, num: 1, checked: item.productRelation !== null && item.productRelation.isStock === 0 })) || []
    originIngredient.value = [...ingredient.value]
    checked.value = ingredient.value.map((item: _Ingredient) => item.id)
    const cookBookTypeStr = data.value!.data?.cookTypeStr || ''
    const ids = cookBookTypeStr.split(',')

    stepsList.value = data.value!.data?.steps || []

    try {
      // 前人设置的规则，不管我事
      // 2024-10-30 16:08:00 => cookBookTypeStr = ',烹飪廚具,餐類,簡易度,節日,'
      // 以后这个索引对应的什么就不知道了。。。。。
      rate.value = Number.parseInt(ids[3]) - 19
    }
    catch (e) {
      console.error(e)
    }
  }
}, {
  deep: true,
  immediate: true,
})

const details = computed<_RecipeDetail>(() => {
  return data.value?.data || {} as _RecipeDetail
})

// 食譜類型
const recipeType = computed<string>(() => {
  return recipeTypeOption.value.find(item => item.value === details.value.ctype)?.text || ''
})

// hashTag
const hashTag = computed<string[]>(() => {
  return details.value?.hashTag ? details.value?.hashTag.split(',') : []
})

function stritem(cookBookTypeList: _WCookbookTypeList[]) {
  const cookBookTypeStr = details.value?.cookTypeStr || ''
  const ids = cookBookTypeStr.split(',')
  return ids.map((id) => {
    const item = cookBookTypeList.find(item => item.id === Number(id))
    // eslint-disable-next-line ts/ban-ts-comment
    // @ts-expect-error
    return locale.value === 'en' ? item?.name_en : item?.name
  }).filter(item => item).join(',')
}

function handlePlus() {
  ingredient.value.map((item) => {
    if (item.checked) {
      item.num = item.num + 1
    }
    return item
  })
}
function handleMinus() {
  ingredient.value.map((item) => {
    if (item.checked) {
      item.num = item.num - 1
    }
    return item
  })
}

const totalPrice = computed(() => {
  return Number.parseFloat(ingredient.value.filter(item => item.checked && item.productRelation).reduce((acc, item) => {
    return math.add(acc, (math.multiply(item.num, Number.parseFloat(item.productRelation.price as unknown as string))))
  }, 0) as unknown as string)
})

/** 是否可以一键购买 */
const canBay = computed<boolean>(() => {
  // 登录 、已购买、总价格 > 0、观看积分是0
  return !((isBay.value || !(data.value?.data?.watchPoints)) === true && totalPrice.value > 0)
})
/** 显示css模糊 */
const showFilter = computed(() => {
  // 如果是作者
  if (isAuthor.value) {
    return false
  }
  // 如果观看积分为0
  if (!data.value?.data?.watchPoints) {
    return false
  }
  // 如果是已购买
  return !isBay.value
})

const showDialog = computed(() => {
  // 如果是作者
  if (isAuthor.value) {
    return false
  }
  // 如果观看积分为0
  if (!data.value?.data?.watchPoints) {
    return false
  }
  // 如果是已购买
  return !isBay.value
})

/** 购买loading */
const loading = ref<boolean>(false)

// function checkedLang() {
//   Lang.value = Lang.value === LocaleMap.TW ? LocaleMap.EN : LocaleMap.TW
//   setLocale(Lang.value)
// }

function handleAddCart(formData: any) {
  return new Promise((resovle) => {
    $fetch('/ichi_api/shoppingCart/addShoppingCartScode', {
      params: {
        MESSAGE: formatQuery(formData),
      },
      onResponse({ response }) {
        resovle(response._data)
      },
    })
  })
}

/**
 * 一键购买
 * @description 循环添加到购物车
 */
function onSubmit() {
  if (!isLogin.value) {
    showConfirmDialog({
      message: t('recipe.noLogin.message'),
    }).then(() => {
      navigateTo(localPath({
        path: '/login',
        query: {
          redirect: route.fullPath,
        },
      }))
    })

    return
  }
  if (canBay.value) {
    return
  }
  const request = ingredient.value.filter(item => item.checked && item.productRelation).map(async (item) => {
    const formData = {
      scode: item.productRelation.code,
      count: item.num,
      name: item.productRelation.name.trim(),
      img: item.productRelation.picture,
      price: item.productRelation.price,
      cat: item.productRelation.cat.trim(),
      origin: 1, // 购物车来源0->默认,1->食谱
      cookbookId: details.value.name.trim(),
      customerId: userinfo.value?.id || 0,
      custCode: userinfo.value?.custCode,
      mbType: userinfo.value?.mbType,
    }

    return handleAddCart(formData)
  })
  loading.value = true
  Promise.all(request).then(() => {
    cartStore.syncCart()
    showNotify({
      type: 'success',
      message: t('notify.success'),
    })
  }).finally(() => {
    loading.value = false
  })
}

// 购买食谱
async function handleBay() {
  if (!userinfo.value?.id) {
    // 跳转登录
    navigateTo(localPath({
      path: '/login',
      query: {
        redirect: route.fullPath,
      },
    }))
    return
  }

  // 购买
  const formData = {
    id: details.value.id,
    customerId: userinfo.value?.id,
    custCode: userinfo.value?.custCode,
    mbType: userinfo.value?.mbType,
  }

  await $fetch('/ichi_api/wCookbook/buy', {
    method: 'post',
    params: {
      MESSAGE: formatQuery(formData),
    },
    onResponse({ response }) {
      if (response._data.success) {
        // 购买成功
        isBay.value = true
      }
      else {
        showNotify({
          message: response._data?.data?.msg || response._data?.msg || response._data?.message || response.statusText,
        })
      }
    },
  })
}

// function onClickLeft() {
//   navigateTo(localPath('/recipe'), { replace: true })
//   // router.back()
// }
// function conversionTool() {
//   navigateTo(localPath('/toolManagement/conversionTool'))
// }

/**
 * 点赞
 */
function handleUp() {
  if (!userinfo.value?.id)
    return

  $fetch<_ResponseType<any>>('/api/wCookbook/up', {
    method: 'POST',
    params: {
      MESSAGE: formatQuery({
        id: details.value.id,
        customerId: userinfo.value.id,
        custCode: userinfo.value.custCode,
        mbType: userinfo.value.mbType,
      }),
    },
  }).then((res) => {
    if (res && res.success) {
      details.value.isUp = details.value.isUp === 'no' ? 'yes' : 'no'
    }
  })
}

/**
 * 收藏
 */
function handleCollect() {
  if (!userinfo.value?.id)
    return

  $fetch<_ResponseType<any>>('/api/wCookbook/collector', {
    method: 'POST',
    params: {
      MESSAGE: formatQuery({
        id: details.value.id,
        customerId: userinfo.value.id,
        custCode: userinfo.value.custCode,
        mbType: userinfo.value.mbType,
      }),
    },
  }).then((res) => {
    if (res && res.success) {
      details.value.isCo = details.value.isCo === 'no' ? 'yes' : 'no'
    }
  })
}

const moreContent = ref()

const { data: seoData, status: seoStatus } = await useFetch<_Seo[]>('/api/seoRelation/list', {
  method: 'POST',
  body: {
    paths: [useRoute().path],
  },
})

watch(() => seoStatus.value, (newVal) => {
  if (newVal === 'success') {
    if (seoData.value && Array.isArray(seoData.value) && seoData.value.length) {
      const { content } = JSON.parse(JSON.stringify(seoData.value)).pop()
      moreContent.value = content.content
      const { title, meta } = content
      useHead({
        title,
        meta,
      })
    }
  }
}, {
  immediate: true,
})
</script>

<template>
  <div class="main">
    <with-header left-arrow with-search search-type="recipe" />
    <!-- <van-nav-bar left-arrow placeholder fixed @click-left="onClickLeft">
      <template #title>
        <img
          class="logo"
          src="~/assets/image/logo.png"
          alt=""
          @click="navigateTo(localPath('/'))"
        >
      </template>
      <template #right>
        <svgo-weighing
          filled
          class="mr-3 text-xl"
          @click="conversionTool"
        />
        <div @click="checkedLang">
          <svgo-en
            v-if="Lang !== LocaleMap.TW"
            filled
            class="text-xl"
          />
          <svgo-ft
            v-else
            filled
            class="text-xl"
          />
        </div>
      </template>
    </van-nav-bar> -->
    <div class="banner">
      <img v-if="details?.coverImgUrl" :src="details?.coverImgUrl">
      <img v-else src="~/assets/image/提拉米蘇.jpg" alt="">
    </div>
    <div class="info">
      <div class="title mb-2">
        <div>{{ details?.name }}</div>
        <div class="ml-1 min-w-23 flex flex-row justify-around gap-x-2">
          <div>
            |
          </div>
          <div class="flex items-start justify-end whitespace-nowrap text-theme">
            <svgo-integrals
              filled
              class="text-2xl"
            />
            <span class="text-base">{{ details?.watchPoints }}</span>
            <span class="text-base">{{ t("integral") }}</span>
          </div>
        </div>
      </div>
      <div font-size-14px>
        <ClientOnly>
          <van-row :gutter="[20, 20]">
            <van-col v-for="tag in tags" :key="tag.id" span="12">
              <div
                flex
                items-center
              >
                <svgo-festival v-if="tag.id === 5" filled class="text-xl" />
                <svgo-simplicity v-if="tag.id === 3" filled class="text-xl" />
                <svgo-cuisine v-if="tag.id === 2" filled class="text-xl" />
                <svgo-kitchenware v-if="tag.id === 1" filled class="text-xl" />
                <div ml-1>
                  {{ locale === 'en' ? tag.nameEn : tag.name }}
                </div>
              </div>
              <div ml-6>
                <van-rate
                  v-if="tag.id === 3"
                  v-model="rate"
                  readonly
                  color="#743a3a"
                  size="16"
                />
                <span v-else>
                  {{ stritem(tag.cookBookTypeList) }}
                </span>
              </div>
            </van-col>

            <van-col span="12">
              <div
                flex
                items-center
              >
                <svgo-recipetype
                  filled
                  class="text-xl"
                />
                <div ml-1>
                  {{ t("Recipe type") }}
                </div>
              </div>
              <div ml-6>
                {{ recipeType }}
              </div>
            </van-col>
            <van-col span="12">
              <div
                flex
                items-center
              >
                <svgo-time
                  filled
                  class="text-xl"
                />
                <div ml-1>
                  {{ t("time") }}
                </div>
              </div>
              <div ml-6>
                {{ details.cookingTime }}分鐘
              </div>
            </van-col>
            <van-col span="12">
              <div
                flex
                items-center
              >
                <svgo-use
                  filled
                  class="text-xl"
                />
                <div ml-1>
                  {{ t("use") }}
                </div>
              </div>
              <div ml-6>
                {{ details.useType }}
              </div>
            </van-col>
          </van-row>
        </ClientOnly>
      </div>
    </div>
    <div class="tags">
      <van-button
        v-for="(tag, index) in hashTag"
        :key="tag + index"
        size="small"
        plain
        round
        color="#743a3a"
        :to="localPath(`/hashtag/${tag}`)"
      >
        #{{ tag }}
      </van-button>
    </div>
    <div class="material-info">
      <div class="title">
        <svgo-seasoning
          filled
          class="text-xl"
        />
        <div>{{ t("Material") }}</div>
      </div>
      <ClientOnly>
        <div class="flex flex-col gap-y-3">
          <van-checkbox
            v-for="item in ingredient"
            :key="item.id"
            v-model="item.checked"
            checked-color="#743a3a"
            label-disabled
            :disabled="!(item.productRelation && item.productRelation?.isStock === 0)"
          >
            <div class="material-item">
              <div class="flex items-center gap-x-2">
                <template v-if="item.productRelation">
                  <img
                    :src="item.productRelation.picture"
                    :alt="item.productRelation.name"
                  >
                </template>
                <template v-else>
                  <img src="/images/empty-recipe.svg">
                </template>
                <div w-150px>
                  <template v-if="item.productRelation">
                    <div class="w-full overflow-hidden text-ellipsis whitespace-nowrap text-nowrap">
                      {{ item.productRelation.name || '' }}
                    </div>
                    <div>{{ item.productRelation.weight }}</div>
                    <div class="material-price">
                      HK${{ item.productRelation.price?.toFixed(2) }}
                    </div>
                  </template>
                  <template v-else>
                    {{ item.ingredients }}
                  </template>
                </div>
              </div>
              <div>{{ item.count }}{{ item.unit }}</div>
              <template v-if="item.productRelation">
                <template v-if="item.productRelation.isStock === 0">
                  <van-stepper
                    v-model="item.num"
                    theme="round"
                    button-size="22px"
                    input-width="30px"
                  />
                </template>
                <template v-else>
                  <div class="w-78px">
                    {{ t('product.outOfStock') }}
                  </div>
                </template>
              </template>
              <template v-else>
                <div class="w-78px" />
              </template>
            </div>
          </van-checkbox>
        </div>
      </ClientOnly>
    </div>
    <!-- 烹饪步骤 -->
    <div class="cooking-teps">
      <div class="title">
        <svgo-steps
          filled
          class="text-xl"
        />
        <div>{{ t("Cooking steps") }}</div>
      </div>
      <!-- 弹窗 -->
      <div
        v-if="showDialog"
        class="dialog left-20% bg-[#fff] py-5 text-center shadow-lg"

        absolute top-100px z-1 w-250px rounded-10px
      >
        <svgo-lock
          filled
          class="ml-45% text-2xl"
        />

        <div v-if="!isBay" mt-2 font-size-16px font-600>
          {{ t("Recipes require points to purchase", { num: details?.watchPoints }) }}
        </div>
        <div v-if="!isLogin" mt-2 font-size-16px font-600>
          登录后立即解锁内容
        </div>
        <div v-if="!isBay" font-size-12px>
          <span>{{ t("Dear member your current account has") }}</span>
          <span class="text-[#743a3a]">{{ userinfo?.integral }}</span>
          <span class="text-[#743a3a]">{{ t("integral") }}</span>
        </div>
        <van-button
          color="#743a3a"
          round
          size="small"
          mt-3
          w-180px
          font-size-14px
          @click="handleBay"
        >
          <div v-if="!isBay">
            {{ t("Buy it now") }}
          </div>
          <div v-if="!isLogin">
            {{ t('Go to login') }}
          </div>
        </van-button>
      </div>
      <div
        :class="{
          steps: showFilter,
        }"
      >
        <div
          v-for="(item, index) in stepsList"
          :key="item.id"
          class="steps-info"
        >
          <div class="steps-number">
            {{ index + 1 }}
          </div>
          <div class="steps-content">
            <img :src="item.imgUrl ?? '~/assets/image/提拉米蘇.jpg'">
            <div>
              <div>步骤{{ item.step }}</div>
              <div>{{ item.note }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mybelike">
      <div>{{ t("Recipes you may like") }}</div>
      <div
        class="content"
        mt-5
      >
        <recipe-list :recipes="moreRecipes" />
      </div>
    </div>
    <div
      v-if="isLogin && isAuthor"
      class="fkex-row fixed bottom-130px right-20px h-14 w-14 flex items-center justify-center rounded-full bg-theme"
      @click="navigateTo(localPath(`/recipe/form/${details.id}`))"
    >
      <SvgoRiEditBoxLine class="text-3xl text-white" />
    </div>
    <van-submit-bar placeholder safe-area-inset-bottom>
      <template #button>
        <div v-if="details.isCo || details.isUp" class="flex basis-1/3 flex-row gap-x-4">
          <div class="flex flex-col items-center justify-center" @click="handleCollect">
            <!-- <svgo-RiHeartLine v-if="details.isCo === 'no'" class="text-2xl" />
            <svgo-RiHeartFill v-if="details.isCo === 'yes'" class="text-2xl text-theme" /> -->
            <img
              v-if="details.isCo === 'no'" :src="unnamed" alt="" width="24" height="24" style="height: 1.5rem;margin-bottom: .125em; vertical-align: middle;width: 1.5rem;"
            >
            <svgo-collect v-if="details.isCo === 'yes'" filled class="text-2xl text-theme" />
            <div class="text-sm" :class="[details.isCo === 'yes' ? 'text-theme' : '']">
              {{ locale === 'tw' ? '收藏' : 'Collect' }}
            </div>
          </div>
          <div class="flex flex-col items-center justify-center" @click="handleUp">
            <svgo-RiThumbUpLine v-if="details.isUp === 'no'" class="text-2xl" />
            <svgo-RiThumbUpFill v-if="details.isUp === 'yes'" class="text-2xl text-theme" />
            <div class="text-sm" :class="[details.isUp === 'yes' ? 'text-theme' : '']">
              {{ locale === 'tw' ? '點贊' : 'Like' }}
            </div>
          </div>
        </div>
        <van-button color="#743a3a" round block :disabled="canBay" :loading="loading" @click="onSubmit">
          {{ t('One click purchase') }}
        </van-button>
      </template>
      <template #top>
        <div class="cart-info">
          <div class="number">
            <svgo-cart class="text-[#743a3a]" />
            <div mx-2>
              {{ t("Required amount") }}
            </div>
            <van-stepper
              v-model="value2"
              theme="round"
              button-size="20"
              @plus="handlePlus"
              @minus="handleMinus"
            />
          </div>
          <div class="tatol">
            <div>{{ t("total") }}：</div>
            <div>HK${{ totalPrice.toFixed(2) }}</div>
          </div>
        </div>
      </template>
    </van-submit-bar>
  </div>
</template>

<style lang="scss" scoped>
.main {
  // height: calc(100vh - 100px);
  // overflow-y: auto;
  background-color: #f7f7f7;
  padding-bottom: 30px;
}
// :deep(.van-nav-bar) {
//   --van-nav-bar-height: 52px;
//   background-color: #743a3a;
//   z-index: 2;
//   .logo {
//     width: 4.375rem;
//   }
//   // .van-nav-bar__content {
//   //   height: 5.625rem;
//   // }
//   .van-icon {
//     color: #fff;
//   }
// }
.banner {
  max-height: 344px;
  // margin-top: 5.625rem;
  img {
    width: 100%;
    height: 100%;
    max-height: 344px;
    object-fit: cover;
  }
}
.info {
  background-color: #fff;
  padding: 1.25rem;
  .title {
    display: flex;
    font-size: 18px;
    font-weight: 600;
  }
}
.tags {
  margin-top: 9px;
  background-color: #fff;
  padding: 17px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  gap: 11px;
}
.material-info {
  margin-top: 0.625rem;
  background-color: #fff;
  padding: 1.25rem;
  font-size: 14px;
  :deep(.van-checkbox__label) {
    flex: 1;
  }
  .title {
    display: flex;
    align-items: center;
    div {
      font-weight: 600;
      margin-left: 0.3125rem;
    }
  }
  .material-item {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    img {
      box-sizing: border-box;
      border: 1px solid #e8e8e8;
      width: 55px;
      height: 55px;
      border-radius: 10px;
      object-fit: cover;
    }
    .material-price {
      color: #743a3a;
    }
  }
}
.cooking-teps {
  position: relative;
  margin-top: 0.625rem;
  background-color: #fff;
  font-size: 14px;

  .title {
    display: flex;
    align-items: center;
    padding: 1.25rem 0 0 1.25rem;
    div {
      font-weight: 600;
      margin-left: 0.3125rem;
    }
  }
  .steps {
    /* 设置高斯模糊 */
    filter: blur(8px);
  }
  .steps-info {
    display: flex;

    padding: 1.25rem;
    position: relative;
    .steps-content {
      flex: 1;
      display: flex;
      img {
        width: 6.25rem;
        height: 6.25rem;
        object-fit: cover;
        border-radius: 0.625rem;
        margin-right: 0.625rem;
      }
      div {
        font-size: 14px;
        color: #000;
      }
    }
    .steps-number {
      width: 25px;
      height: 25px;
      color: #fff;
      border-radius: 50%;
      text-align: center;
      line-height: 25px;
      background-color: #743a3a;
      font-size: 16px;
      margin-right: 0.625rem;
      z-index: 1;
    }
  }
  .steps-info::before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: calc(1.25rem + 25px / 2);
    width: 2px;
    border-left: 1px dashed #ccc;
    z-index: 0;
  }
  .steps-info:nth-child(even) {
    background-color: #f4f1ec;
  }
  .steps-info:first-child::before {
    top: 1.25rem;
  }
  .steps-info:last-child:before {
    height: 1.25rem;
  }
}
.mybelike {
  margin-top: 1.25rem;
  margin-bottom: 30px;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  .content {
    text-align: left;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 20px;
    padding: 0 20px;
    margin-bottom: 1.875rem;
  }
}
.cart-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.625rem;
  margin-bottom: 0.625rem;
  div {
    font-size: 14px;
  }
  .number {
    display: flex;
    align-items: center;
  }
  .tatol {
    display: flex;
    align-items: center;

    div:last-child {
      color: #743a3a;
      font-size: 16px;
      font-weight: 600;
    }
  }
}
</style>
